import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { List as ImmutableList } from 'immutable';
import { Grid, Typography } from '@material-ui/core';
import { MultipleSelect } from 'common/components';
import { ICameFromIndicatorDictionaryItemImt } from 'common/interfaces/dictionary';
import { useRenderIntlMessage } from 'common/hooks/useRenderIntlMessage';
import messages from 'common/components/Steps/MemberPrimaryInfoStep/messages';
import inputLabels from 'common/messages/inputLabels';
import CameFromFields from 'common/components/ReactHookForm/CameFromFields/CameFromFields';
import { IImmutablePrimaryMemberInfo } from 'common/components/PersonProfile/interfaces';
import { TShortProfileFieldInfoImt } from 'modules/corporate-settings/interfaces';
import { RequiredProfileInfo } from 'modules/corporate-settings/constants/requiredFields';
import { IEmployeeBasicInfo } from 'interfaces/employee.interfaces';
import { makeEmployeeOptions } from 'utils/employee.utils';
import { SearchReferralMembersReturn } from 'common/hooks/useSearchReferralMembers';

interface ISalesInfoSection {
  primaryInfo?: IImmutablePrimaryMemberInfo;
  employees: IEmployeeBasicInfo[];
  cameFromIndicators?: ImmutableList<ICameFromIndicatorDictionaryItemImt>;
  recommendedFields: TShortProfileFieldInfoImt;
  getReferralsByValue: SearchReferralMembersReturn;
}

const SalesInfoSection: FC<ISalesInfoSection> = ({
  employees,
  cameFromIndicators,
  recommendedFields,
  primaryInfo,
  getReferralsByValue,
}) => {
  const renderIntlMessage = useRenderIntlMessage();
  const { control, formState } = useFormContext();
  const { errors } = formState;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="button" color="textSecondary">
          <FormattedMessage {...messages.newMemberPrimaryInfoSalesInfo} />
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Controller
          name="salesperson"
          control={control}
          render={({ field }) => (
            <MultipleSelect
              fullWidth
              label={<FormattedMessage {...inputLabels.salesperson} />}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              error={!!errors.salesperson}
              helperText={renderIntlMessage(errors?.salesperson?.message)}
              recommended={Boolean(recommendedFields?.get(RequiredProfileInfo.Salesperson))}
              options={makeEmployeeOptions(employees)}
            />
          )}
        />
      </Grid>

      <CameFromFields
        cameFromIndicators={cameFromIndicators}
        cameFromIndicator={primaryInfo?.get('cameFromIndicator')}
        referralMember={primaryInfo?.get('referralMember')}
        getReferralsByValue={getReferralsByValue}
      />
    </Grid>
  );
};

export default React.memo(SalesInfoSection);
